{[ if (o.label) { ]}
<label>
    {{{o.label}}}
</label>
{[ } ]}
<img src="data:{{{o.type}}};base64,{{{o.data}}}">
<input name="{{{o.name}}}" type="text" {[ if (o.required) { ]} required="required" {[ } ]} />


